var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4171 26.9304H7.98418L5.40993 16.8206C5.28774 16.3556 5.02831 15.9444 4.64669 15.7507C3.69431 15.2637 2.64486 14.8762 1.5 14.6807V14.2915H7.03013C7.79337 14.2915 8.3658 14.8762 8.46121 15.5552L9.79688 22.8477L13.2281 14.2915H16.5656L11.4171 26.9304ZM18.4737 26.9304H15.2316L17.9013 14.2915H21.1434L18.4737 26.9304ZM25.3378 17.7929C25.4332 17.1121 26.0057 16.7229 26.6735 16.7229C27.723 16.6252 28.8661 16.8206 29.8202 17.3059L30.3926 14.5847C29.4386 14.1955 28.3891 14 27.4367 14C24.2901 14 22.0003 15.7507 22.0003 18.1804C22.0003 20.0288 23.6222 20.9993 24.7671 21.584C26.0057 22.167 26.4827 22.5563 26.3873 23.1393C26.3873 24.0137 25.4332 24.403 24.4809 24.403C23.336 24.403 22.1911 24.1115 21.1434 23.6245L20.5709 26.3474C21.7158 26.8327 22.9544 27.0281 24.0992 27.0281C27.6276 27.1242 29.8202 25.3752 29.8202 22.75C29.8202 19.4441 25.3378 19.2504 25.3378 17.7929ZM41.1667 26.9304L38.5924 14.2915H35.8273C35.2549 14.2915 34.6825 14.6807 34.4917 15.2637L29.7248 26.9304H33.0623L33.7284 25.0837H37.8292L38.2108 26.9304H41.1667ZM36.3044 17.6951L37.2567 22.4585H34.5871L36.3044 17.6951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.06934c8cafa73b943a4e0ad037f57638.svg";
export { ForwardRef as ReactComponent };